import { render, staticRenderFns } from "./CentroProcessesMatrix.vue?vue&type=template&id=889715d0"
import script from "./CentroProcessesMatrix.vue?vue&type=script&lang=js"
export * from "./CentroProcessesMatrix.vue?vue&type=script&lang=js"
import style0 from "./CentroProcessesMatrix.vue?vue&type=style&index=0&id=889715d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports